module.exports = __webpack_public_path__ + "static/Wisteria-54892ef47ca8a621365a43178ed01f99.woff";